import React, { useEffect, useState } from "react";
import "./styles.scss";
// import {
//   AWS_BUCKET_REGION,
//   AWS_BUCKET_POOL,
//   AWS_BUCKET_NAME,
//   AWS_BUCKET_ACL,
// } from "../../../config/env/env";
import { Spinner } from "../index";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { LightBoxImage } from "../index";
import { FormHelperText, Typography, Box } from "@mui/material";
import axios from "axios";
import imageCompression from 'browser-image-compression'
import { showMessage } from "../../../Utils/helper";
// const IMAGE_FILES = ['.jpg', '.png', '.jpeg', '.bmp'];
const NON_IMAGE_FILES = [".xlsx", ".csv", ".pdf", ".html"];

export function FileUploader({
  render,
  label,
  labelStyles,
  placeholder,
  uploadUrl,
  onUpload,
  onFileUploaded,
  defaultValue,
  helperText,
  disabled,
  error,
  onRemoved,
  hideRemove,
  lightboxConfig = {},
  isRequired,
  ...props
}) {
  const [uploadedFile, setuploadedFile] = useState(defaultValue ?? "");
  const [loading, toggleLoading] = useState(false);

  useEffect(() => {
    setuploadedFile(defaultValue);
  }, [defaultValue]);

  const uploadfile = async (e, uploadTo) => {
    await toggleLoading(true);
    const input = e.target;
    const imageFile = input.files[0];
    if (!imageFile) {
      toggleLoading(false);
      return;
    }
    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      // Backend accepts only JPEG/PNG, so convert other formats (e.g. HEIC) when uploading via the server
      ...(onUpload ? { fileType: "image/jpeg" } : {}),
    }
    let compressedFile;
    try {
      compressedFile = await imageCompression(imageFile, options);
    } catch (err) {
      toggleLoading(false);
      input.value = "";
      showMessage("Unable to read this photo. Please try a different one.", "error");
      return;
    }

    // Upload through the backend (used for the profile photo, which is checked before it is stored)
    if (onUpload) {
      try {
        const resp = await onUpload(compressedFile);
        if (resp?.status) {
          onFileUploaded("");
        } else if (!resp?.silent) {
          showMessage(resp?.result || "Unable to upload photo", "error");
        }
      } catch (err) {
        showMessage("Unable to upload photo. Please retry", "error");
      }
      input.value = "";
      toggleLoading(false);
      return;
    }

    delete axios.defaults.headers.common["Authorization"];
    axios
      .put(uploadTo, compressedFile, {
        headers: {
          "Content-Type": "image/png",
        },
        onUploadProgress: (ProgressEvent) => {
        },
      })
      .then((res) => {
        toggleLoading(false);
        onFileUploaded("");
      })
      .catch((err) => {
        toggleLoading(false);
      });
  };

  const removeimage = () => {
    setuploadedFile("");
    onRemoved && onRemoved();
  };

  function getFileNameFromS3() {
    return uploadedFile.split("/")[uploadedFile.split("/").length - 1];
  }

  return (
    <>
      {!!label && (
        <Typography
          variant="body1"
          style={
            labelStyles
              ? {
                  fontSize: "14px",
                  fontWeight: "normal",
                  marginTop: 10,
                  marginBottom: 0,
                  padding: 0,
                  color: Boolean(error) ? "#F44336" : "#14112D",
                  ...labelStyles,
                }
              : {
                  fontSize: "14px",
                  fontWeight: "normal",
                  marginTop: 10,
                  marginBottom: 0,
                  padding: 0,
                  color: Boolean(error) ? "#F44336" : "#515f6d",
                }
          }
        >
          {label}
          {isRequired && <span style={{ color: "red" }}>*</span>}
        </Typography>
      )}
      <Spinner loading={loading}>
        <div className="file-upload">
          {!!uploadedFile ? (
            <div
              className={`image-upload-wrap ${
                Boolean(error) ? "img-border-error" : ""
              }`}
            >
              {/* <div className="drag-text"> */}
              {!!uploadedFile &&
              !NON_IMAGE_FILES.find((file) =>
                uploadedFile.toLowerCase().includes(file)
              ) ? (
                <div className="drag-text image-drag">
                  <LightBoxImage {...lightboxConfig} source={uploadedFile} />
                </div>
              ) : (
                <div className="drag-text">
                  <AttachFileIcon />
                  {
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "flex-end",
                      }}
                    >
                      {/* <AttachFileIcon /> */}
                      <Typography
                        // variant="body1"
                        style={{
                          color: "red",
                          marginLeft: "2px",
                          width: "100%",
                          wordWrap: "break-word",
                        }}
                      >
                        {/* {`${uploadedFile}`} */}
                        {`${getFileNameFromS3()}`}
                      </Typography>
                    </Box>
                  }
                </div>
              )}
              {/* </div> */}
              {!disabled && (
                <div className="upload-actions">
                  <label className="upload-action-btn">
                    <input
                      className="upload-action-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => uploadfile(e, uploadUrl)}
                    />
                    <EditOutlinedIcon fontSize="small" />
                    Change
                  </label>
                  {!hideRemove && (
                    <button
                      type="button"
                      className="upload-action-btn upload-action-remove"
                      onClick={() => removeimage()}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                      Remove
                    </button>
                  )}
                </div>
              )}
            </div>
          ) : !render ? (
            <div
              className={`image-upload-wrap ${
                Boolean(error) ? "img-border-error" : ""
              }`}
            >
              <input
                className="file-upload-input"
                type="file"
                onChange={(e) => uploadfile(e, uploadUrl)}
                accept="image/*"
              />
              <div className="drag-text">
                <span className="upload-icon-circle">
                  <AddAPhotoOutlinedIcon />
                </span>
                <Typography variant="body1" className="upload-title">
                  Click to choose a photo
                </Typography>
                <Typography variant="caption" className="upload-hint">
                  JPG or PNG
                </Typography>
              </div>
            </div>
          ) : (
            <div className={` ${Boolean(error) ? "img-border-error" : ""}`}>
              <input
                className="file-upload-input"
                type="file"
                onChange={(e) => uploadfile(e, uploadUrl)}
              />
              {render()}
            </div>
          )}
        </div>
        {Boolean(error) && (
          <FormHelperText className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
            {helperText}
          </FormHelperText>
        )}
      </Spinner>
      {loading && !!onUpload && (
        <Typography
          variant="body2"
          style={{ color: "#515f6d", marginTop: 6, textAlign: "center" }}
        >
          Checking your photo. This may take a few seconds, please wait...
        </Typography>
      )}
    </>
  );
}
